import { render } from "./StandardModal.vue?vue&type=template&id=5101e789&scoped=true"
import script from "./StandardModal.vue?vue&type=script&lang=js"
export * from "./StandardModal.vue?vue&type=script&lang=js"

import "./StandardModal.vue?vue&type=style&index=0&id=5101e789&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5101e789"]])

export default __exports__